export const fieldsInfoAboutExistingCertificate = {
  licenseNumExist: {
    key: "licenseNumExist",
    value: "Номер",
    type: "text",
    readOnly: true,
    // required: true,
    needInWindow: true,
  },
  licenseDateExist: {
    key: "licenseDateExist",
    value: "Дата выдачи",
    type: "date",
    readOnly: true,
    // required: true,
    needInWindow: true,
  },
};
